import styled from "styled-components";
import { cssMainSelector } from "../lib/cssSelectors";

const Label = styled.span`
  ${p => cssMainSelector(p.theme.tdsId)} {
    display: inline-block;
    background-color: ${p => p.theme.color.darkGray};
    border-radius: ${p => p.theme.generic.borderRadius};
    color: ${p => p.theme.color.white};
    font-size: ${p => (p.small ? "10px" : "")};
    font-weight: ${p => p.theme.font.weightBold};
    line-height: ${p => (p.small ? "12px" : "16px")};
    padding: 1px 4px;
    text-align: center;
    white-space: nowrap;
    vertical-align: ${p => (p.small ? "1.5px" : "")};
  }
`;

const PrimaryLabel = styled(Label)`
  ${p => cssMainSelector(p.theme.tdsId)} {
    background-color: ${p => p.theme.color.cornFlowerBlue};
  }
`;

const Label4G = styled(Label)`
  ${p => cssMainSelector(p.theme.tdsId)} {
    background-color: ${p => p.theme.color.mediumTurquoise};
    font-weight: ${p => p.theme.font.weightBold};
  }
`;

const Label5G = styled(Label)`
  ${p => cssMainSelector(p.theme.tdsId)} {
    background-color: ${p => p.theme.color.darkSlateBlue};
    font-weight: ${p => p.theme.font.weightBold};
  }
`;

export { Label, PrimaryLabel, Label4G, Label5G };
